module.exports = __webpack_public_path__ + "img/es.e07f87cf.svg";